export class ExternalSpecial {
  entityId! : string;
  entityRevision! : number;
  externalId! : string;
  original!: boolean;
  specialQty!: number;
  pricePerUnit!: number;
  setupFee!: number;
  quoteStatus!: string;
  description!: string;
  externalSpecialRequestId!: string;
}
